import { render, staticRenderFns } from "./BookingPayments.vue?vue&type=template&id=3ff63677&scoped=true&"
import script from "./BookingPayments.vue?vue&type=script&lang=ts&"
export * from "./BookingPayments.vue?vue&type=script&lang=ts&"
import style0 from "./BookingPayments.vue?vue&type=style&index=0&id=3ff63677&scoped=true&lang=scss&"
import style1 from "./BookingPayments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff63677",
  null
  
)

export default component.exports